export default function MaskCpfCnpj(value) {

    let v = value
    //Remove tudo o que não é dígito
    v = v.replace(/\D/g, "")
    if(v.length !== 0){
        v = v.substr(0, 8)
    }
        //Coloca um - entre o quinto e o sexto dígitos
        v = v.replace(/(\d{5})(\d)/, "$1-$2")

    return v;
}